export const PLAN_SCHEDULE_ENTITY_TYPE_VALUES = {
  OBJECTIVE: 'OBJECTIVE',
  ACTION: 'ACTION',
  KPI: 'KPI'
}

export const PLAN_SCHEDULE_OBJECTIVE_FORM_PREFIX = 'PLAN_SCHEDULE_DEFAULTS_OBJECTIVE_FORM'

export const PLAN_SCHEDULE_FLAT_SECTIONS = [
  {
    key: 'action',
    entityType: PLAN_SCHEDULE_ENTITY_TYPE_VALUES.ACTION,
    label: 'Actions',
    form: 'PLAN_SCHEDULE_DEFAULTS_ACTION_FORM'
  },
  {
    key: 'kpi',
    entityType: PLAN_SCHEDULE_ENTITY_TYPE_VALUES.KPI,
    label: 'Indicators',
    form: 'PLAN_SCHEDULE_DEFAULTS_KPI_FORM'
  }
]
